import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

const ListTable = ({
  loading,
  data,
  onTableChange,
  pagination,
  columns,
  rowKey,
}) => {
  return (
    <div className="table-responsive doctor-list">
      <Table
        loading={loading}
        onChange={onTableChange}
        pagination={pagination}
        columns={columns}
        dataSource={data}
        rowKey={rowKey}
      />
    </div>
  );
};

ListTable.propTypes = {
  loading: PropTypes.bool, // Refer the `ant` table for more details on this prop
  data: PropTypes.array, // Refer the `ant` table for more details on this prop
  onTableChange: PropTypes.func, // Refer the `ant` table for more details on this prop
  pagination: PropTypes.any, // Refer the `ant` table for more details on this prop
  columns: PropTypes.array, // Refer the `ant` table for more details on this prop
  rowKey: PropTypes.func,
};

export default ListTable;
